export default __webpack_public_path__ + "form-section-v2-blob-1.svg";